<template>
  <div class="login_remis_customer">
    <div class="container">
      <div class="row">
        <div class="col-md-6 login_remis_first_section">
          <img
            src="https://epump.com.ng/images/logo2.svg"
            class="company_logo"
            width="130"
          />

          <div class="login_remis_text">
            {{ $t("text.passwordResetConfirmation.resetYourPassword") }}
          </div>

          <div class="row m-hide">
            <div class="col-md-6 col-sm-12 login-remis-img remove-left-padding">
              <img src="../../assets/img/cars.png" class="w-100" />
            </div>
            <div class="col-md-6 col-sm-12 login-remis-img remove-left-padding">
              <img src="../../assets/img/nossel.png" class="w-100" />
            </div>
            <div
              class="col-md-6 col-sm-12 login-remis-img mt-3 remove-left-padding"
            >
              <img src="../../assets/img/motorbike-fleet.png" class="w-100" />
            </div>
            <div class="col-md-6 login-remis-img mt-3 remove-left-padding">
              <img src="../../assets/img/car-speed.png" class="w-100" />
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-2">
          <div class="login_remis_section small-login-wrapper mt-5 pt-5">
            <h4 class="pt-5">
              {{ $t("text.passwordResetConfirmation.resetPassword") }}
            </h4>
            <form>
              <div class="remis_login_field">
                <label>{{
                  $t("text.passwordResetConfirmation.emailAddress")
                }}</label>
                <input
                  v-model="email"
                  @blur="checkEmail"
                  :class="!emailFormatGood ? 'red_back' : null"
                />
              </div>
              <div class="mt-5">
                <button
                  @click="resetPassword"
                  :disabled="disableButton"
                  :class="disableButton ? 'login_loading' : null"
                >
                  <p v-if="!disableButton">
                    {{ $t("text.passwordResetConfirmation.resetPassword") }}
                  </p>
                  <div class="loader_spinner">
                    <pulse-loader
                      :color="color"
                      size="15px"
                      v-if="disableButton"
                    ></pulse-loader>
                  </div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundUrl from "@/assets/img/img_2.jpg";
import configObject from "@/config";
import EpumpLoader from "@/components/EpumpLoader";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  title: "Reset Password:: Epump Portal",
  name: "AccountConfirmation",
  components: {
    EpumpLoader,
    PulseLoader,
  },
  data() {
    return {
      color: this.$store.getters.loaderColor,
      backgroundUrl,
      formIsValid: false,
      email: "",
      disableButton: false,
      emailFormatGood: true,
    };
  },
  methods: {
    checkEmail() {
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3500,
        });
        this.emailFormatGood = false;
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        this.emailFormatGood = false;
        return;
      }
      this.emailFormatGood = true;
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    resetPassword(event) {
      event.preventDefault();
      this.checkEmail();
      if (!this.emailFormatGood) return;
      this.disableButton = true;
      this.axios
        .post(`${configObject.apiBaseUrl}/Account/ForgetPassword/${this.email}`)
        .then((response) => {
          this.disableButton = false;
          this.$toast.open({
            message: this.$t("text.resetPassword.linkSent"),
            type: "success",
            duration: 3000,
          });
          this.$router.push({ name: `password_email_notification` });
        })
        .catch((error) => {
          this.disableButton = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
